// extracted by mini-css-extract-plugin
export default {"eApporovalWrapper":"EApprovalTabs_eApporovalWrapper__nZcQ5","writeBtn":"EApprovalTabs_writeBtn__-kWD3"};